<template>
  <div class="combination-product">
    <jd-button type="blue" @click="selectProduct" class="mb16" :disabled="isDisabled">
      选择商品（{{ newPrizeList.length }}/{{ limitNum }}）
    </jd-button>
    <slot name="tips"></slot>
    <slot name="price-tips"></slot>
    <jd-table
      :tableInfo="tableInfo"
      rowKey="skuId"
      :tableData="newPrizeList"
      style="flex: 1"
      v-show="newPrizeList.length > 0"
    >
      <template #productSlot="{ row }">
        <div class="goods-box">
          <img :src="row.logo" alt="" />
          <div class="ml8">
            <div>商品名称：{{ row.skuName }}</div>
            <div>SKUID：{{ row.skuId }}</div>
          </div>
        </div>
      </template>
      <template #promotionPrice="{ row }">
        <!-- 保留两位小数 -->
        <el-input
          v-model="row.promoPrice"
          placeholder="请输入"
          class="w125"
          @input="handlePromoPriceInput(row, $event)"
          @blur="handlePromoPriceBlur(row)"
        />
      </template>
      <!-- 单商品优惠库存 -->
      <template #totalAmount="{ row }">
        <!-- 保留两位小数 -->
        <el-input
          v-model="row.totalAmount"
          placeholder="请输入"
          class="w125"
          @input="row.totalAmount = getNumberData(1, $event, 0, 1, 999999)"
        />
      </template>
      <template #operation="{ row, rowIndex }">
        <div>
          <jd-button
            type="blueText"
            @click="upPrizeSetting(rowIndex)"
            v-if="rowIndex != 0"
            >上移</jd-button
          >
          <jd-button
            type="blueText"
            @click="downPrizeSetting(rowIndex)"
            v-if="rowIndex != newPrizeList.length - 1"
            >下移</jd-button
          >
          <jd-button type="blueText" @click="removeProduct(rowIndex)" :disabled="isDisabled">
            删除
          </jd-button>
        </div>
      </template>
    </jd-table>
    <!-- 商品设置弹框 -->
    <selectGoods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      @close="getGoodsDate"
      :selectGoods="newPrizeList"
      :moduleType="true"
      :skuSearch="true"
      :limitNum="limitNum"
      :isLimit="isLimit"
      :disabled="isDisabled"
    ></selectGoods>
  </div>
</template>
<script>
import selectGoods from "@/components/selectGoodsMonitor2";
export default {
  components: {
    selectGoods,
  },
  props: {
    tableInfo: {
      type: Array,
      default: () => [],
    },
    prizeList: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    limitNum: {
      type: Number,
      default: 20,
    },
    isLimit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowGoods: false,
      newPrizeList: [],
    };
  },
  computed: {},
  watch: {
    prizeList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.newPrizeList = newVal;
        }
      },
      immediate: true,
    },
    newPrizeList: {
      handler(newVal, oldVal) {
        this.$emit("update:prizeList", newVal);
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getGoodsDate(data) {
      console.log(data,'5454');
      if (data && data.length > 0) {
        this.newPrizeList = []
        data.forEach((item,index)=>{
          let obj = {};
          obj.skuId = item.skuId;
          obj.skuName = item.skuName || item.wareTitle;
          obj.logo = item.logo;
          obj.jdPrice = item.jdPrice;
          obj.promoPrice = item.promoPrice || "";
          obj.totalAmount = item.totalAmount || "";
          this.newPrizeList.push(obj);
        })
        // this.newPrizeList = data.map((item) => {
        //   let obj = {
        //     skuId: "",
        //     skuName: "",
        //     logo: "",
        //     jdPrice: "",
        //     promoPrice: "",
        //     totalAmount: "",
        //   };
        //   obj.skuId = item.skuId;
        //   obj.skuName = item.skuName || item.wareTitle;
        //   obj.logo = item.logo;
        //   obj.jdPrice = item.jdPrice;
        //   return obj;
        // });
      }
      this.isShowGoods = false;
    },
    // 选择商品:最多选择20个
    selectProduct() {
      if (this.newPrizeList.length >= this.limitNum) {
        this.$message({
          message: `最多选择${this.limitNum}个商品`,
          type: "warning",
        });
        return;
      }
      this.isShowGoods = true;
    },
    upPrizeSetting(index) {
      this.newPrizeList[index] = this.newPrizeList.splice(
        index - 1,
        1,
        this.newPrizeList[index]
      )[0];
    },
    downPrizeSetting(index) {
      this.newPrizeList[index] = this.newPrizeList.splice(
        index + 1,
        1,
        this.newPrizeList[index]
      )[0];
    },
    removeProduct(index) {
      // 二次确认删除
      this.$confirm('确认删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.newPrizeList.splice(index, 1);
      });
    },
    // 处理促销价输入，确保不大于京东价
    handlePromoPriceInput(row, event) {
      // 数字格式化处理
      row.promoPrice = this.getNumberData(1, event, 1, 0);
      // 获取京东价（转为数字，保留两位小数）
      const jdPrice = parseFloat(row.jdPrice) || 0;
      const promoPrice = parseFloat(row.promoPrice) || 0;
      // 如果促销价大于京东价，自动修正为京东价并提示
      if (promoPrice > jdPrice) {
     
        row.promoPrice = Number(jdPrice);
        this.$message({
          message: '促销价不能大于京东价',
          type: 'warning',
        });
      }
    },
    // 去除最后面的小数点
    handlePromoPriceBlur(row) {
      if(row.promoPrice.endsWith('.')){
        row.promoPrice = row.promoPrice.slice(0, -1);
      } 
    },
  },
};
</script>
<style lang="scss" scoped>
.combination-product {
  width: 100%;
  // flex: 1;
  .goods-box {
    padding: 10px;
    display: flex;
    align-items: center;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.w125 {
  width: 125px;
}
</style>